import * as React from "react";
import type { SVGProps } from "react";
const BuildingSupplyStore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clip0_4355_5217)">
      <g fill="currentColor" clipPath="url(#clip1_4355_5217)">
        <path d="M14.5081 17.9141H6.8474a.5466.5466 0 0 0-.5466.5466v3.8303c0 .302.2447.5467.5466.5467h7.6607a.5466.5466 0 0 0 .5467-.5467v-3.8302a.5467.5467 0 0 0-.5467-.5467m9.4454 0h-7.6607a.5466.5466 0 0 0-.5467.5466v3.8303c0 .302.2447.5467.5467.5467h7.6607a.5466.5466 0 0 0 .5467-.5467v-3.8302a.5467.5467 0 0 0-.5467-.5467M6.8474 11.6696h7.6607a.5466.5466 0 0 0 .5467-.5466V7.2928a.5466.5466 0 0 0-.5467-.5467H6.8474a.5466.5466 0 0 0-.5466.5466v3.8303c0 .3019.2447.5466.5466.5466M23.9535 6.746h-7.6607a.5466.5466 0 0 0-.5467.5467v3.8303c0 .3019.2447.5466.5467.5466h7.6607a.5466.5466 0 0 0 .5467-.5466V7.2928a.5467.5467 0 0 0-.5467-.5467m-12.5006-.6604h7.6608a.5466.5466 0 0 0 .5466-.5467V1.7088a.5466.5466 0 0 0-.5466-.5467h-7.6608a.5467.5467 0 0 0-.5467.5467V5.539c0 .3019.2448.5467.5467.5467m-.3904 6.791v3.8304c0 .302.2447.5467.5467.5467h7.6607a.5466.5466 0 0 0 .5466-.5467v-3.8304a.5466.5466 0 0 0-.5466-.5466h-7.6607a.5465.5465 0 0 0-.5467.5466m-.8084 3.8304v-3.8304a.5466.5466 0 0 0-.5467-.5466H2.0467a.5466.5466 0 0 0-.5467.5466v3.8304c0 .302.2447.5467.5467.5467h7.6607a.5465.5465 0 0 0 .5467-.5467" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_4355_5217">
        <path fill="transparent" d="M0 0h24v24H0z" />
      </clipPath>
      <clipPath id="clip1_4355_5217">
        <path fill="transparent" d="M1.5.5h23v23h-23z" />
      </clipPath>
    </defs>
  </svg>
);
export default BuildingSupplyStore;
